import { IP_ENDPOINT, TIMEOUTS } from '@/config/targets'

/**
 * The source IP as the platform sees it. Used when WebRTC gives us no address — and note that it
 * only answers if TCP 443 to the API host is open, so a fully blocked firewall reports neither.
 */
export async function fetchServerSeenIp(): Promise<string | null> {
	const controller = new AbortController()
	const timer = setTimeout(() => controller.abort(), TIMEOUTS.ipLookup)

	try {
		const response = await fetch(IP_ENDPOINT, {
			cache: 'no-store',
			credentials: 'omit',
			signal: controller.signal
		})
		if (!response.ok) return null

		const body: unknown = await response.json()
		const ip = (body as { ip?: unknown })?.ip
		return typeof ip === 'string' && ip.length > 0 ? ip : null
	} catch {
		return null
	} finally {
		clearTimeout(timer)
	}
}
